import CommonApp from '../../app.js';
import markup from './page-level-msgs.html';
import {cookieUtil} from '../../../util/cookie-util.js';
import {strings} from '../../../util/strings.js';
import {configManager} from '../../../util/config-manager/config-manager.js';
import {AccountConfigManager} from '../../../util/config-manager/AccountConfigManager';

CommonApp.module.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
CommonApp.module.service('configManager', function() {
    return configManager;
});

CommonApp.module.component('nsPageLevelMsg', {
    template: markup,
    bindings: {
        // need to add bindings when ever requires
        // pageLevelErrorMsg: '='
    },
    controller: PageLevelMsgController,
    controllerAs: 'ctrl'

});


var PageLevelMsgController = function(pageLevelMsgService, $window, $rootScope, $scope, $timeout, configManager, AccountConfigManager) {
    var self = this;
    this.dangerType = false;
    this.errorMessage = 'Error!';
    this.successType = false;
    this.successMessage = 'Success!';
    this.successDescription = false;
    this.isShowInfoIconOnError = true;
    this.strings = strings;

    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    this.dismissBanners = accountConfigManager.site['dismissBanners'];

    this.init = function() {
        self.dangerType = false;
        self.successType = false;
        self.isSessionExpired();


        var gigyaId = self.getQueryStringValue('gigyaId');
        if (undefined != gigyaId && null != gigyaId && 0 < gigyaId.length) {
            var promise = pageLevelMsgService.setEmailFlagGigya(gigyaId);
            promise.then(function(data) {
                self.successType = true;
                self.successMessage = 'Your Email Address is successfully verified!';
                self.successDescription = false;
                self.hideSuccessMsg();
            });
        }
    };
    this.getQueryStringValue = function(key) {
        return unescape($window.location.search.replace(new RegExp('^(?:.*[&\\?]'
            + escape(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
    };

    self.hideSuccessMsg = function() {
        if (self.successType) {
            $timeout(function() {
                self.successType = false;
                $scope.$apply();
            }, 6000);
        }
    };

    self.hideErrorMsg = function() {
        if (self.dangerType) {
            $timeout(function() {
                self.dangerType = false;
                $scope.$apply();
            }, 6000);
        }
    };

    this.isSessionExpired = function() {
        var isSessionExpired = '';
        if (cookieUtil.getCookie('isSessionExpired') != undefined && cookieUtil.getCookie('isSessionExpired') != '') {
            isSessionExpired = cookieUtil.getCookie('isSessionExpired');
        }
        if (isSessionExpired) {
            self.successType = false;
            self.dangerType = true;

            var sessionExpMsg = angular.element($('#sessionexpiredmsg')).val();
            self.errorMessage = sessionExpMsg;
            self.hideErrorMsg();
        }
        cookieUtil.deleteCookie('isSessionExpired');
    };

    $rootScope.$on('accountCreated', function(event, args) {
        self.dangerType = false;
        self.successType = true;
        if (args) {
            if (args.successMessage) {
                self.successMessage = args.successMessage;
            }
            if (args.successDescription) {
                self.successDescription = args.successDescription;
            }
        }
        self.hideSuccessMsg();
    });

    $rootScope.$on('emailVerified', function(event, args) {
        self.dangerType = false;
        var gigyaId = self.getQueryStringValue('gigyaId');
        if (undefined != gigyaId && null != gigyaId && 0 < gigyaId.length) {
            var promise = pageLevelMsgService.setEmailVerificationFlag(gigyaId);
            promise.then(function(data) {
                self.successType = true;
                self.successMessage = 'Your Email Address is successfully verified!';
                self.successDescription = false;
                self.hideSuccessMsg();
            });
        }
    });

    $rootScope.$on('distributorConversionFailure', function(event, args) {
        self.dangerType = true;
        if (args.errorMessage) {
            self.errorMessage = args.errorMessage;
        } else {
            self.errorMessage = 'Please Try again later...';
        }
        self.hideErrorMsg();
    });

    $rootScope.$on('isSystemErrorOccured', function(event, args) {
        self.dangerType = true;
        var sessionExpMsg = angular.element($('#SystemErrorOccuredMsg')).val();
        self.successMessage = sessionExpMsg;
        self.errorMessage = 'Oops!!! Something went wrong ';
        $('#errorMsgToast').show();
        self.hideErrorMsg();
    });

    $rootScope.$on('isServiceCallFailure', function(event, args) {
        self.dangerType = true;
        self.errorMessage = args;
        self.hideErrorMsg();
    });
    $rootScope.$on('storefrontPageLevelError', function(event, args) {
        self.dangerType = true;
        self.errorMessage = args.errorData.errorMessage;
        self.isShowInfoIconOnError = args.errorData.showInfoIconOnError;
    });

    $rootScope.$on('emailSuccessfullySent', function(event, args) {
        self.dangerType = false;
        self.successType = true;
        if (args) {
            self.successMessage = args.successMessage ? args.successMessage : 'Email sent successfully';
            self.successDescription = args.successDescription ? args.successDescription : '';
        }
        self.hideSuccessMsg();
    });

    $rootScope.$on('emailSentError', function(event, args) {
        self.dangerType = true;
        self.successType = false;
        if (args) {
            self.errorMessage = args.errorMessage ? args.errorMessage : 'Email failed.';
        }
        self.hideErrorMsg();
    });

    $rootScope.$on('addToBagSuccessMsg', function(event, args) {
        self.dangerType = false;
        self.successType = true;
        if (args) {
            self.successMessage = args.successMessage;
            self.successUrl = args.successUrl ? args.successUrl : '';
            self.successUrlText = args.successUrlText ? args.successUrlText : '';
        }
        self.hideSuccessMsg();
    });

    $rootScope.$on('addToBagFailureMsg', function(event, args) {
        self.dangerType = true;
        self.errorMessage = args;
        self.hideErrorMsg();
    });
};

PageLevelMsgController.$inject = ['pageLevelMsgService', '$window', '$rootScope', '$scope', '$timeout', 'configManager', 'AccountConfigManager'];
CommonApp.module.controller('pageLevelMsgController', PageLevelMsgController);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/page-level-messages/page-level-msgs.js
// module id = 247
// module chunks = 0